import { c as _c } from "react/compiler-runtime";
import useChatWidgetLayout, { type ChatWidgetLayout } from './use-chat-widget-layout';
import useChatWidgetOpen from './use-chat-widget-open';
import { useInvestigationDockRelease } from './use-investigation-dock';
const useChatWidgetLayoutSwitch = () => {
  const $ = _c(4);
  const {
    setMode
  } = useChatWidgetLayout();
  const {
    open
  } = useChatWidgetOpen();
  const releaseDock = useInvestigationDockRelease();
  let t0;
  if ($[0] !== open || $[1] !== releaseDock || $[2] !== setMode) {
    t0 = layout => {
      releaseDock();
      open();
      setMode(layout);
    };
    $[0] = open;
    $[1] = releaseDock;
    $[2] = setMode;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export default useChatWidgetLayoutSwitch;